export const environment = {
  production: false,
  //captchakey: '6LcWIMYUAAAAAI8aJtExk8m3i-slHev-X9Xhxkd8', //prod
  captchakey: '6LeFrZ0aAAAAAIZvNKM-Elu2zHM3MRyFRlqozb97',
  oldCheckout: 'https://dev.portaltransbank.cl/afiliacion/registrate.html#/login/15',
  linkAgendaWix: 'https://calendly.com/transbank-cl/wix-onboard',
  getSeleccionProductosDelay: 2000,
  getResumenDelay: 30000,
  keytaqManager:'GTM-58TP7HL',
  isGA4tagManager:true,
  numberPartners: 2,
  localStorage: {
    CURRENT_PAGE: 'CP',
    PASO_0: 'P_0',
    PASO_1: 'P_1',
    PASO_2: 'P_2',
    PASO_3: 'P_3',
    LOADING: 'P_LOADING'
  },
  api: {
    host: '',
    path: '/bff-checkout/api/checkout',
    pathMarketplace: '/bff-checkout/api/marketplace',
    endpoints: {
      marketplace:{
        UF: '/uf',
        valoresMCC: '/valores-mcc'
      },
      PASO_1: {
        AUTH: '/auth',
        loginCampania: '/login-campania',
        guardarCorreoNotificacion: '/notificacion-correo'
      },
      checkout: {
        auth: '/checkout/auth',
        documents: {
          requiredDocument: '/documento/documentos-requeridos',
          documentStatus: '/documento/estado-documentos',
          saveDocument: '/documento/documentos',
          deleteDocument: '/documento/documentos'
        }
      },
      PASO_2: {
        PERSONA: '/persona',
        NACIONALIDADES: '/parametros/nacionalidades',
        VALIDA_EDICION_2: '/paso-2/valida-edicion-paso-2',
        SELECCION_PRODUCTO: '/producto/seleccion-producto',
        CUENTA_ABONO: '/cuenta-abono',
        IDENTIFICACION_COMERCIO: '/comercio/identificacion-comercio',
        DATOS_COMERCIO: '/comercio/datos-comercio',
        LOCALIZACIONES: '/parametros/localizaciones',
        BANCO: '/parametros/bancos',
        PROVEEDORES: '/parametros/proveedores',
        CONFIGURACION_PRODUCTO: '/producto/configuracion-producto',
        VALIDA_CI_PERSONA: '/persona/valida-ci',
        PERSONA_JURIDICA:{
          SOCIO: '/socio',
          SOCIOS: '/representantes-legales',
          VALIDA_CI_SOCIO: '/socio/valida-ci',
          EMPRESA_UN_DIA: '/empresa-un-dia'
        },
        UAF: '/declaracion-uaf'
      },
      PASO_3: {
        VALIDA_EDICION: '/paso-tres/valida-edicion-paso-tres',
        CONTACTO_AGENDAMIENTO: '/contacto',
        CUOTAS: '/cuotas',
        DECLARACION_JURADA: '/declaracion-uaff',
        ANEXO_CONTRATO: '/anexo-contrato/',
        ESTADO_ANEXOS: 'estado-anexos',
        APRUEBA_DOCUMENTO: 'aprueba-documento',
        APRUEBA_ANEXO_COMERCIO: 'aprueba-anexo-comercio',
        APRUEBA_ANEXO_REPRESENTANTE: 'aprueba-anexo-representante',
        TIPO_APROBACION: 'tipo-aprobacion',
        VALIDA_PAGO_PRODUCTO: '/producto/valida-pago-producto',
        DIRECCION_INSTALACION: '/direccion/instalacion',
        OBTENER_URL_PAGO: '/producto/url-pago',
        AGENDA: '/paso-tres/agenda',
        CARTA_PODER: '/comercio/carta-poder',
        PREVIEW_CONTRATO: '/anexo-contrato/preview',
        RESUMEN: '/paso-tres/resumen',
        LLAMAR_CLIENTE:'/comercio/llamar-cliente',
        AUTENTICA_COMERCIO:'/comercio/autentica-comercio',
        VALIDA_ESTADO_FIRMA: '/paso-tres/valida-estado-firma',
        SIGUIENTES_PASOS: '/paso-tres/obtiene-siguientes-pasos',
        OBTIENE_RESUMEN_PAGO: '/producto/resumen-pago',
        VALIDA_DESCUENTO: '/producto/descuento/',
        VALIDA_PAGO_PRODUCTO_EJECUTIVO: '/producto/valida-pago-proactivo/'
      }
    }
  },
  redirections: {
    marketplace: 'https://tienda.qa1.tbk.cl/',
    requestInProgress: 'https://trazabilidad.qa1.tbk.cl/#!/',
    portalPrivado: 'https://www.transbank.cl/portal-public/?_ga',
    trazabilidad: 'https://trazabilidad.qa1.tbk.cl/#!/',
    portalPublico: 'https://publico.transbank.cl/',
    urlTerminos: 'https://publico.transbank.cl/documents/121605/12716227/TyC+portal+Privado+Versi%C3%B3n+VF.pdf',
    urlPrivacidad: 'https://publico.transbank.cl/documents/121605/12716227/Aviso+de+Privacidad+web+TBK++-+VF+-+Julio+2023.pdf',
    ayudatransbank: 'https://ayuda.transbank.cl/nueva-ley-de-cumplimiento-tributario-en-que-consiste-la-normativa',
    urlTbkAmigo: 'https://privadoqa3.transbank.cl/activatuequipo',
    urlDocServTarifas: 'https://publico.transbank.cl/documents/20129/0/Servicios+y+Tarifas+a+Establecimientos+Comercios.pdf',
    urlBackoffice: "https://dev.portaltransbank.cl/backofficev2/#/app/pro/form-pro-afiliacion"
  },
  urlQueryParam: {
    productsParameterName: 'trolley',
    tokenParameterName: 'token',
    ejecutivoParamName: 'ejecutivo'
  },
  documentosAdjuntos: {
    obtenerEstadoDocumentoDelay: 2000
  },
  retoma: {
    parameterName: 'action',
    parameterValue: 'retoma'
  },
  storage: 'localStorage',
  valorIVA: 1.19,
  marcaGa4DesdeMarkectplace:"mdcp",
  fieldValidations:{
    numeroSeriePatterns: [
      { 2002: "/^[aA]{1}[0-9]{9}$/" },
      { 2013: "/^[0-9]{9}$/" },
      { 2024: "/^[a-zA-Z0-9]{9}$/" }
    ]
  }
};

